module.exports = __webpack_public_path__ + "static/profile-pic-36c50b14536fd94bc71a977b2fd6b686.png";